import React from 'react';
import { motion } from 'framer-motion';

interface IntegrationCardProps {
  name: string;
  description: string;
  icon: React.ReactNode;
  color: string;
  delay?: number;
  onLearnMore?: (name: string) => void;
}

const IntegrationCard: React.FC<IntegrationCardProps> = ({ name, description, icon, color, delay = 0, onLearnMore }) => {
  return (
    <motion.div
      className="flex flex-col rounded-xl shadow-sm hover:shadow-md transition-all overflow-hidden"
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ delay }}
      whileHover={{ y: -5 }}
    >
      <div className={`p-5 ${color}`}>
        <div className="flex items-center space-x-3">
          {/* Icon container with styling to center the icon */}
          <div className="flex items-center justify-center w-12 h-12 rounded-full bg-white bg-opacity-50">
            {/* Apply styling to the SVG icon */}
            <div className="text-primary-700">
              {icon}
            </div>
          </div>
          <h3 className="text-lg font-semibold text-gray-800">{name}</h3>
        </div>
      </div>
      <div className="p-5 bg-white flex-grow">
        <p className="text-gray-600">{description}</p>
      </div>
      <div className="p-4 bg-white border-t border-gray-100 flex justify-end">
        <button 
          className="text-primary-600 hover:text-primary-700 text-sm font-medium transition-colors"
          onClick={() => onLearnMore && onLearnMore(name)}
        >
          Learn more →
        </button>
      </div>
    </motion.div>
  );
};

export default IntegrationCard;